import React__default from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { kebabCase } from 'lodash';
import { NvTabs, NvTab } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { isServer } from '../../utils/misc.esm.js';
import styles from './TabsSection.module.esm.js';

var TabsSection = function (_a) {
    var _b;
    var _c = _a.fields, analyticsEvents = _c.analyticsEvents, internalName = _c.internalName, items = _c.items, heading = _c.heading, subheading = _c.subheading, body = _c.body, alignment = _c.alignment, id = _a.id, dataCy = _a["data-cy"];
    var onRoutePush = React__default.useCallback(function (path) {
        if (!isServer())
            window.history.pushState({ path: path }, '', path);
    }, []);
    var path = !isServer() ? window.location.pathname : '';
    var searchParams = !isServer() ? window.location.search : '';
    if (items.length === 0)
        return null;
    return (React__default.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: classNames('nv-container', (_b = {}, _b[styles.spacingWrapper] = heading, _b)), "data-cy": dataCy, id: id, sectionName: internalName },
        React__default.createElement(NvTabs, { alignment: alignment, body: body, defaultTabId: kebabCase(items[0].fields.heading), heading: heading, id: "tab", onRoutePush: onRoutePush, pathname: path, searchParam: searchParams, subheading: subheading, withSearchParamsControl: true }, items.map(function (_a) {
            var _b = _a.fields, itemHeading = _b.heading, blocks = _b.blocks;
            return (React__default.createElement(NvTab, { key: itemHeading, tabId: kebabCase(itemHeading), titleText: itemHeading }, blocks.map(function (block) { return (React__default.createElement(BaseNucleobaseComponent, { key: block.sys.id, source: block })); })));
        }))));
};

export { TabsSection as default };
//# sourceMappingURL=TabsSection.esm.js.map
